import Personal from './Personal'
import Identification from './Identification'
import Address from './Address'
import Finance from './Finance'
import Experience from './Experience'
import Profile from './Profile'
import WorkInfo from './WorkInfo'

const TabComponents = {
    Personal,
    Identification,
    Address,
    Finance,
    Experience,
    Profile,
    WorkInfo,
}

export default TabComponents
